import sk from "./sk.json";
import en from "./en.json";
import cz from "./cz.json";
import de from "./de.json";

const skModules = import.meta.glob('./sk/**/*.js', { eager: true });
const enModules = import.meta.glob('./en/**/*.js', { eager: true });
const czModules = import.meta.glob('./cz/**/*.js', { eager: true });

const buildLocale = (modules) =>
    Object.fromEntries(
        Object.entries(modules).map(([path, mod]) => [
            path.match(/\/([^/]+)\.js$/)[1],
            mod.default,
        ])
    );

export default {
    sk: { ...buildLocale(skModules), ...sk },
    en: { ...buildLocale(enModules), ...en },
    cz: { ...buildLocale(czModules), ...cz },
    de: { ...de },
};
